import { FeatureFlag } from "@/__generated__/graphql";
import featureFlagEnabled from "@/utils/featureFlagEnabled";

type WorkspaceWithFlags = {
  featureFlags?: FeatureFlag[];
};

// A workspace is "Managed Agents" when the managed_agents feature flag is
// enabled on it. This is the same signal the agents surfaces gate on, so the
// chrome (banners) and the content stay consistent.
export default function isManagedAgentsWorkspace(workspace: WorkspaceWithFlags | null | undefined): boolean {
  return featureFlagEnabled(workspace, "managed_agents");
}
